import { useState } from 'react';
import { Modal, Button, Space } from 'antd';
import { Col, Row, Form, InputNumber } from 'antd';
import SelectRemetente from './components/SelectRemetente';
import SelectDestinatario from './components/SelectDestinatario';
import SelectCidade from './components/SelectCidade';
import TextFilter from '../../../../components/TextFilter';
import { CloseOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons';

const ModalAdicionarNotaManual = ({ setAtualizarListaNotas, setVisible }: any) => {
  const [visibleModalAdicionarNotaManual, setVisibleModalAdicionarNotaManual] = useState(false);
  const [form] = Form.useForm();
  const [remetente, setRemetente] = useState<any>();
  const [destinatario, setDestinatario] = useState<any>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedCidadeRemetente, setSelectedCidadeRemetente] = useState<any>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedCidadeDestinatario, setSelectedCidadeDestinatario] = useState<any>(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  function incluirNota(result: any) {
    const listaNotasOcorrencia: any = JSON.parse(
      localStorage.getItem(window.location.pathname + `ListaNotas`) || '[]'
    );
    localStorage.setItem(
      window.location.pathname + 'ListaNotas',
      JSON.stringify([...listaNotasOcorrencia, result])
    );
  }

  function onFinish(values: any) {
    setConfirmLoading(true);
    let result = {
      numNota: values.numNota,

      destinatario: destinatario.razaoSocial,
      codDestinatario: destinatario.codParceiro,
      destino: values.cidadeDestinatario,
      codCidadeDestino: +selectedCidadeDestinatario.key,

      remetente: remetente.razaoSocial,
      codRemetente: remetente.codParceiro,
      origem: values.cidadeRemetente,
      codCidadeOrigem: +selectedCidadeRemetente.key,
    };

    incluirNota(result);
    setTimeout(() => {
      form.resetFields();
      setConfirmLoading(false);
      setVisible(false);
      setVisibleModalAdicionarNotaManual(false);
      setAtualizarListaNotas(true);
    }, 1000);
  }

  return (
    <>
      <div style={{ minWidth: '600px' }}>
        <span>Não conseguiu localizar a nota?</span>{' '}
        <Button
          type="link"
          onClick={() => setVisibleModalAdicionarNotaManual(true)}
          icon={<PlusOutlined />}
        >
          Adicione manualmente
        </Button>
      </div>
      <Modal
        title="Cadastro de nota manual"
        centered
        visible={visibleModalAdicionarNotaManual}
        width={900}
        onCancel={() => setVisibleModalAdicionarNotaManual(false)}
        footer={[]}
        confirmLoading={confirmLoading}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row gutter={24}>
            <Col md={8} sm={24} xs={24}>
              <Form.Item
                name="numNota"
                label={<TextFilter>N° da nota</TextFilter>}
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <InputNumber type="number" style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col md={8} sm={24} xs={24}>
              <Form.Item
                name="remetente"
                label={<TextFilter>Remetente</TextFilter>}
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <SelectRemetente name="remetente" setRemetente={setRemetente} />
              </Form.Item>
            </Col>

            <Col md={8} sm={24} xs={24}>
              <Form.Item
                name="cidadeRemetente"
                label={<TextFilter>Cidade Remetente / UF</TextFilter>}
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <SelectCidade setProps={setSelectedCidadeRemetente} name="cidadeRemetente" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col md={8} sm={24} xs={24}>
              <Form.Item
                name="destinatario"
                label={<TextFilter>Destinatário</TextFilter>}
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <SelectDestinatario name="destinatario" setDestinatario={setDestinatario} />
              </Form.Item>
            </Col>

            <Col md={8} sm={24} xs={24}>
              <Form.Item
                name="cidadeDestinatario"
                label={<TextFilter>Cidade destinatário / UF</TextFilter>}
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <SelectCidade setProps={setSelectedCidadeDestinatario} name="cidadeDestinatario" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item style={{ textAlign: 'right', paddingTop: '20px' }}>
            <Space>
              <Button
                onClick={() => {
                  setVisibleModalAdicionarNotaManual(false);
                  form.resetFields();
                }}
                icon={<CloseOutlined />}
              >
                Cancelar
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={confirmLoading}
                icon={<PlusCircleOutlined />}
              >
                Adicionar nota
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ModalAdicionarNotaManual;
